import { ReactElement } from 'react';
import { ZebraLogoName } from '../../../../design/static/logos/ZebraLogoName';
import { ZebraTopLogo } from '../../../../design/static/logos/ZebraTopLogo';
import { ZebraSitePath } from '../../../routes/config/ExternalLinks';

export const AuthLogo = (): ReactElement => {
  return (
    <a
      href={ZebraSitePath}
      target='_blank'
      rel='noopener noreferrer'
    >
      <div className='auth-logo'>
        <ZebraTopLogo className='head' />
        <ZebraLogoName className='text' />
      </div>
    </a>
  );
};
